var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "match-height" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between"
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "mb-0" },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "SettingsIcon", size: "21" }
                                  }),
                                  _vm._v(" Configuração do Workflow ")
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "6" } }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("h6", { staticClass: "text-muted mb-50" }, [
                                _vm._v("Nome do Workflow")
                              ]),
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(_vm.model.name || "-"))
                              ])
                            ])
                          ]),
                          _c("b-col", { attrs: { md: "6" } }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("h6", { staticClass: "text-muted mb-50" }, [
                                _vm._v("Data de Criação")
                              ]),
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(_vm.formatDate(_vm.model.created_at))
                                )
                              ])
                            ])
                          ]),
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("div", [
                              _c("h6", { staticClass: "text-muted mb-50" }, [
                                _vm._v("Descrição")
                              ]),
                              _c("p", {
                                directives: [
                                  {
                                    name: "html-safe",
                                    rawName: "v-html-safe",
                                    value: _vm.model.description || "-",
                                    expression: "model.description || '-'"
                                  }
                                ]
                              })
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex justify-content-end gap-2"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "newsletter_workflows.edit",
                                        expression:
                                          "'newsletter_workflows.edit'"
                                      }
                                    ],
                                    attrs: {
                                      variant: "outline-primary",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.goToEdit(0)
                                      }
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "EditIcon", size: "14" }
                                    }),
                                    _vm._v(" Editar ")
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "outline-secondary",
                                      size: "sm"
                                    },
                                    on: { click: _vm.goBack }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-1",
                                      attrs: { icon: "ArrowLeftIcon" }
                                    }),
                                    _vm._v(" Voltar ")
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "match-height mt-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between"
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "mb-0" },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "CalendarIcon", size: "21" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("newsletter.workflow.timeline")
                                      ) +
                                      " "
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c("b-card-body", [
                    _vm.timelines.length === 0
                      ? _c(
                          "div",
                          { staticClass: "text-center py-3" },
                          [
                            _c("feather-icon", {
                              staticClass: "text-muted mb-1",
                              attrs: { icon: "CalendarIcon", size: "48" }
                            }),
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v("Nenhum cronograma configurado")
                            ])
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "timeline-accordion" },
                          _vm._l(_vm.timelines, function(timeline, index) {
                            return _c(
                              "b-card",
                              {
                                key: timeline.id,
                                staticClass: "mb-2",
                                attrs: { "no-body": "" }
                              },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle",
                                            value: "accordion-" + timeline.id,
                                            expression:
                                              "`accordion-${timeline.id}`"
                                          }
                                        ],
                                        staticClass:
                                          "flex items-center w-full p-1 cursor-pointer transition-colors duration-200",
                                        staticStyle: { "border-radius": "6px" },
                                        on: {
                                          mouseenter: function($event) {
                                            $event.currentTarget.style.backgroundColor =
                                              "#e5e7eb"
                                          },
                                          mouseleave: function($event) {
                                            $event.currentTarget.style.backgroundColor =
                                              "transparent"
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-shrink-0 mr-4" },
                                          [
                                            _c(
                                              "b-avatar",
                                              {
                                                attrs: {
                                                  variant: _vm.getTimelineVariant(
                                                    timeline.status
                                                  ),
                                                  size: "45"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold"
                                                  },
                                                  [_vm._v(_vm._s(index + 1))]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-1 min-w-0" },
                                          [
                                            _c(
                                              "h5",
                                              {
                                                staticClass: "font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      timeline.newsletter.title
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      variant: _vm.getTimelineBadgeVariant(
                                                        timeline.status
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          timeline.status ||
                                                            "PREVISTO"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c("div", { staticClass: "mb-1" }, [
                                              _c(
                                                "small",
                                                { staticClass: "text-muted" },
                                                [
                                                  timeline.newsletter
                                                    .group_news_name ||
                                                  timeline.newsletter
                                                    .subgroup_news_name
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              timeline
                                                                .newsletter
                                                                .group_news_name ||
                                                                "-"
                                                            ) +
                                                            " | " +
                                                            _vm._s(
                                                              timeline
                                                                .newsletter
                                                                .subgroup_news_name ||
                                                                "-"
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "Sem grupo definido"
                                                        )
                                                      ])
                                                ]
                                              )
                                            ]),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center flex-wrap gap-4"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center"
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "mr-2 text-primary",
                                                      attrs: {
                                                        icon: "CalendarIcon",
                                                        size: "16"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-primary font-weight-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                timeline.start_at
                                                              )
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                timeline.end_at
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                timeline.checkpoints &&
                                                timeline.checkpoints.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex items-center"
                                                      },
                                                      [
                                                        _c("feather-icon", {
                                                          staticClass:
                                                            "mr-2 text-muted",
                                                          attrs: {
                                                            icon:
                                                              "CheckCircleIcon",
                                                            size: "14"
                                                          }
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                timeline
                                                                  .checkpoints
                                                                  .length
                                                              ) +
                                                                " ponto(s) de verificação"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "b-collapse",
                                  {
                                    attrs: {
                                      id: "accordion-" + timeline.id,
                                      accordion: "timeline-accordion",
                                      role: "tabpanel"
                                    }
                                  },
                                  [
                                    _c("b-card-body", [
                                      !timeline.checkpoints ||
                                      timeline.checkpoints.length === 0
                                        ? _c(
                                            "div",
                                            { staticClass: "text-center" },
                                            [
                                              _c("feather-icon", {
                                                staticClass: "text-muted mb-1",
                                                attrs: {
                                                  icon: "InfoIcon",
                                                  size: "32"
                                                }
                                              }),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "text-muted mb-0"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "newsletter.workflow.checkpoint.no_checkpoints_configured"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            _vm._l(
                                              timeline.checkpoints,
                                              function(checkpoint, cpIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      checkpoint.id || cpIndex,
                                                    staticClass:
                                                      "checkpoint-section mb-3"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between mb-2"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center"
                                                          },
                                                          [
                                                            _c(
                                                              "b-avatar",
                                                              {
                                                                staticClass:
                                                                  "mr-2 checkpoint-avatar",
                                                                attrs: {
                                                                  variant: _vm.getCheckpointVariant(
                                                                    checkpoint.status
                                                                  ),
                                                                  size: "32"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "CheckCircleIcon",
                                                                      size: "16"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c("div", [
                                                              _c(
                                                                "h6",
                                                                {
                                                                  staticClass:
                                                                    "mb-0"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Ponto de Verificação - " +
                                                                      _vm._s(
                                                                        _vm.formatDate(
                                                                          checkpoint.checkpoint_at
                                                                        )
                                                                      ) +
                                                                      " - "
                                                                  ),
                                                                  _c(
                                                                    "b-badge",
                                                                    {
                                                                      staticClass:
                                                                        "checkpoint-badge",
                                                                      attrs: {
                                                                        variant: _vm.getCheckpointBadgeVariant(
                                                                          checkpoint.status
                                                                        )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            checkpoint.status ||
                                                                              "PREVISTO"
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkpoint-actions"
                                                          },
                                                          [
                                                            _c(
                                                              "vs-dropdown",
                                                              {
                                                                staticClass:
                                                                  "cursor-pointer",
                                                                attrs: {
                                                                  "vs-custom-content":
                                                                    "",
                                                                  "vs-trigger-click":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    staticClass:
                                                                      "h-5 w-5 stroke-current text-muted",
                                                                    attrs: {
                                                                      icon:
                                                                        "MoreVerticalIcon"
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "vs-dropdown-menu",
                                                                  [
                                                                    !_vm.hasCheckpointStatistics(
                                                                      checkpoint
                                                                    )
                                                                      ? _c(
                                                                          "vs-dropdown-item",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "permission",
                                                                                rawName:
                                                                                  "v-permission",
                                                                                value:
                                                                                  "newsletter_workflows.edit",
                                                                                expression:
                                                                                  "'newsletter_workflows.edit'"
                                                                              }
                                                                            ]
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "flex checkpoint-menu-item",
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.generateCheckpointStatistics(
                                                                                      timeline,
                                                                                      checkpoint
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "w-2/12"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "feather-icon",
                                                                                      {
                                                                                        attrs: {
                                                                                          icon:
                                                                                            "BarChart2Icon",
                                                                                          svgClasses:
                                                                                            "h-5 w-5 mb-1 stroke-current text-success"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "w-10/12"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "flex text-success font-medium"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "action.generate_statistics"
                                                                                              )
                                                                                            ) +
                                                                                            " "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "vs-dropdown-item",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "permission",
                                                                            rawName:
                                                                              "v-permission",
                                                                            value:
                                                                              "newsletter_workflows.edit",
                                                                            expression:
                                                                              "'newsletter_workflows.edit'"
                                                                          }
                                                                        ]
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "flex checkpoint-menu-item",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.generateCheckpointReport(
                                                                                  timeline,
                                                                                  checkpoint
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "w-2/12"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "feather-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      icon:
                                                                                        "FileTextIcon",
                                                                                      svgClasses:
                                                                                        "h-5 w-5 mb-1 stroke-current text-primary"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "w-10/12"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "flex text-primary font-medium"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "action.generate_report"
                                                                                          )
                                                                                        ) +
                                                                                        " "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    checkpoint.data
                                                      ? _c(
                                                          "b-row",
                                                          {
                                                            staticClass: "mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "EyeIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .views_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Visualizações",
                                                                      color:
                                                                        "primary"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "HeartIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .likes_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Curtidas",
                                                                      color:
                                                                        "danger"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "MessageSquareIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .comments_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Comentários",
                                                                      color:
                                                                        "warning"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "EditIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .signatures_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Assinaturas",
                                                                      color:
                                                                        "success"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "AlertCircleIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .comments_not_accepted_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Comentários Rejeitados",
                                                                      color:
                                                                        "danger"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  lg: "4",
                                                                  md: "6",
                                                                  sm: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "statistic-card-horizontal",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "ClockIcon",
                                                                      statistic:
                                                                        checkpoint
                                                                          .data
                                                                          .comments_without_moderator_count ||
                                                                        0,
                                                                      "statistic-title":
                                                                        "Aguardando Moderação",
                                                                      color:
                                                                        "info"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "b-alert",
                                                          {
                                                            staticClass:
                                                              "mb-0 text-center",
                                                            attrs: {
                                                              show: "",
                                                              variant: "light"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center justify-content-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-50",
                                                                    attrs: {
                                                                      icon:
                                                                        "InfoIcon",
                                                                      size: "18"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "Estatísticas não disponíveis para este ponto de verificação"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                    checkpoint.media &&
                                                    checkpoint.media.length > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-3"
                                                          },
                                                          [
                                                            _c(
                                                              "h6",
                                                              {
                                                                staticClass:
                                                                  "mb-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "feather-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-50",
                                                                    attrs: {
                                                                      icon:
                                                                        "FileTextIcon",
                                                                      size: "16"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(
                                                                  " Relatórios Gerados (" +
                                                                    _vm._s(
                                                                      checkpoint
                                                                        .media
                                                                        .length
                                                                    ) +
                                                                    ") "
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "reports-list"
                                                              },
                                                              _vm._l(
                                                                _vm.getSortedMedia(
                                                                  checkpoint
                                                                ),
                                                                function(
                                                                  media
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        media.id,
                                                                      staticClass:
                                                                        "report-item"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "report-info"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "feather-icon",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2 text-danger",
                                                                              attrs: {
                                                                                icon:
                                                                                  "FileIcon",
                                                                                size:
                                                                                  "18"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "flex-grow-1"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0 font-weight-bold"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      media.name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "small",
                                                                                {
                                                                                  staticClass:
                                                                                    "text-muted"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Gerado em " +
                                                                                      _vm._s(
                                                                                        _vm.formatDateTime(
                                                                                          media.created_at
                                                                                        )
                                                                                      ) +
                                                                                      " • " +
                                                                                      _vm._s(
                                                                                        _vm.formatFileSize(
                                                                                          media.size
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "report-actions"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-button",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  modifiers: {
                                                                                    hover: true
                                                                                  }
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                variant:
                                                                                  "outline-info",
                                                                                size:
                                                                                  "sm",
                                                                                title:
                                                                                  "Visualizar Relatório"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.previewReport(
                                                                                    media
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "feather-icon",
                                                                                {
                                                                                  attrs: {
                                                                                    icon:
                                                                                      "EyeIcon",
                                                                                    size:
                                                                                      "14"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "b-button",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  modifiers: {
                                                                                    hover: true
                                                                                  }
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                variant:
                                                                                  "outline-primary",
                                                                                size:
                                                                                  "sm",
                                                                                title:
                                                                                  "Baixar Relatório"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.downloadReport(
                                                                                    media
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "feather-icon",
                                                                                {
                                                                                  attrs: {
                                                                                    icon:
                                                                                      "DownloadIcon",
                                                                                    size:
                                                                                      "14"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "b-button",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  modifiers: {
                                                                                    hover: true
                                                                                  }
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                variant:
                                                                                  "outline-warning",
                                                                                size:
                                                                                  "sm",
                                                                                title:
                                                                                  "Enviar Relatório"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.sendSpecificCheckpointReport(
                                                                                    timeline,
                                                                                    checkpoint,
                                                                                    media
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "feather-icon",
                                                                                {
                                                                                  attrs: {
                                                                                    icon:
                                                                                      "SendIcon",
                                                                                    size:
                                                                                      "14"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "b-button",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "permission",
                                                                                  rawName:
                                                                                    "v-permission",
                                                                                  value:
                                                                                    "newsletter_workflows.edit",
                                                                                  expression:
                                                                                    "'newsletter_workflows.edit'"
                                                                                },
                                                                                {
                                                                                  name:
                                                                                    "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  modifiers: {
                                                                                    hover: true
                                                                                  }
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                variant:
                                                                                  "outline-danger",
                                                                                size:
                                                                                  "sm",
                                                                                title:
                                                                                  "Excluir Relatório"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteCheckpointReport(
                                                                                    timeline,
                                                                                    checkpoint,
                                                                                    media
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "feather-icon",
                                                                                {
                                                                                  attrs: {
                                                                                    icon:
                                                                                      "Trash2Icon",
                                                                                    size:
                                                                                      "14"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    cpIndex <
                                                    timeline.checkpoints
                                                      .length -
                                                      1
                                                      ? _c("hr", {
                                                          staticClass: "my-3"
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end gap-2 pt-2" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletter_workflows.edit",
                                expression: "'newsletter_workflows.edit'"
                              }
                            ],
                            attrs: { variant: "outline-primary", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.goToEdit(1)
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "EditIcon", size: "14" }
                            }),
                            _vm._v(" " + _vm._s(_vm.$t("action.manage")) + " ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "match-height mt-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between"
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "mb-0" },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "UsersIcon", size: "21" }
                                  }),
                                  _vm._v(" Destinatários ")
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "b-card-body",
                    [
                      _vm.service && _vm.id
                        ? _c("grid", {
                            ref: "grid-destination",
                            attrs: {
                              hide_actions: true,
                              service: _vm.service,
                              route_grid_path:
                                "/" + _vm.id + "/destinations/grid",
                              route_name: "newsletter_workflows",
                              column_formats: {
                                created_at: function(val) {
                                  return _vm.$utils.format.date(val)
                                },
                                dispatched_at: function(val) {
                                  return _vm.$utils.format.date(val)
                                },
                                status: function(val) {
                                  return "" + val.label
                                }
                              },
                              css_formats: {
                                status: function(val) {
                                  return "text-" + val.color
                                }
                              }
                            }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end gap-2" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: "newsletter_workflows.edit",
                                  expression: "'newsletter_workflows.edit'"
                                }
                              ],
                              attrs: { variant: "outline-primary", size: "sm" },
                              on: {
                                click: function($event) {
                                  return _vm.goToEdit(2)
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EditIcon", size: "14" }
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("action.manage")) + " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("file-preview-modal", {
        attrs: {
          show: _vm.showPreviewModal,
          file: _vm.selectedFile,
          "preview-url": _vm.selectedFile.url_preview
        },
        on: { close: _vm.closePreview, download: _vm.downloadSelectedFile }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }